import { motion } from "framer-motion";
import { fadeUp, stagger, viewport } from "@/lib/motion";

const CHAPTERS = [
  {
    n: "01",
    title: "Genuine, always.",
    body: "Every medicine we dispense is sourced from authorised distributors and stored under proper conditions. No compromises on authenticity, ever.",
  },
  {
    n: "02",
    title: "Care beyond the counter.",
    body: "We take the time to explain dosages, answer questions and remember your family's regular prescriptions — like a neighbour who genuinely cares.",
  },
  {
    n: "03",
    title: "Fair prices, honest advice.",
    body: "Quality healthcare shouldn't be a luxury. We keep medicines affordable and always suggest the right option, not the expensive one.",
  },
  {
    n: "04",
    title: "Here when you need us.",
    body: "Open every single day from 10 AM to 11 PM, with quick local delivery and WhatsApp ordering for those urgent moments.",
  },
];

const ABOUT_IMG =
  "https://images.unsplash.com/photo-1676739119677-bad9c0af002d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwxfHxncmVlbiUyMGNyb3NzJTIwcGhhcm1hY3l8ZW58MHx8fHwxNzg0Mzk5MTMxfDA&ixlib=rb-4.1.0&q=85";

export const About = () => {
  return (
    <section id="about" className="relative bg-white py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          <div className="lg:col-span-5 lg:sticky lg:top-28">
            <motion.p
              initial="hidden"
              whileInView="show"
              viewport={viewport}
              variants={fadeUp}
              className="font-serif-accent italic text-lg text-brand-green"
            >
              About Paliwal Medicos
            </motion.p>
            <motion.h2
              initial="hidden"
              whileInView="show"
              viewport={viewport}
              variants={fadeUp}
              className="mt-3 font-heading font-bold tracking-tight text-ink text-3xl sm:text-4xl lg:text-5xl leading-tight"
            >
              A neighbourhood pharmacy built on trust.
            </motion.h2>
            <motion.p
              initial="hidden"
              whileInView="show"
              viewport={viewport}
              variants={fadeUp}
              className="mt-6 text-base lg:text-lg text-slate-600 leading-relaxed"
            >
              For the families of Shastri Nagar and beyond, Paliwal Medicos is
              more than a medical store. We are a trusted partner in health —
              dedicated to genuine medicines, honest guidance and warm,
              dependable service.
            </motion.p>

            <motion.div
              initial="hidden"
              whileInView="show"
              viewport={viewport}
              variants={fadeUp}
              className="mt-8 overflow-hidden rounded-3xl aspect-[16/10] shadow-[0_20px_40px_rgb(0,0,0,0.08)]"
            >
              <img
                src={ABOUT_IMG}
                alt="Green pharmacy cross sign"
                className="h-full w-full object-cover"
              />
            </motion.div>
          </div>

          <motion.div
            initial="hidden"
            whileInView="show"
            viewport={viewport}
            variants={stagger}
            className="lg:col-span-7 lg:col-start-6"
          >
            {CHAPTERS.map((c) => (
              <motion.div
                key={c.n}
                variants={fadeUp}
                className="group flex gap-6 lg:gap-10 border-b border-slate-200 py-8 first:pt-0 last:border-0"
              >
                <span className="font-heading text-4xl lg:text-5xl font-bold text-slate-200 transition-colors group-hover:text-brand-green/50 shrink-0">
                  {c.n}
                </span>
                <div>
                  <h3 className="font-heading text-xl lg:text-2xl font-semibold text-ink">
                    {c.title}
                  </h3>
                  <p className="mt-2 text-slate-600 leading-relaxed">{c.body}</p>
                </div>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
};
